import LineGraph from "../../LineGraph";
import ArrivalRatesPerDayTable from "../tables/ArrivalRatesPerDayTable";


import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import * as defaultSelectors from "../../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
} from "../../../store/renderConfig";
import { formatNumber } from "../../../store/helpers";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";

const renderCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average);
  if (columnId === "min") return formatNumber(row.min);
  if (columnId === "max") return formatNumber(row.max);
  return null;
};

const ArrivalRatesPerDay = ({ reportIndex = 1, data }) => {
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  });

  const title = `${reportIndex}.1. Entire Organization`;
  let {min, max, chart, average, total} = data;
  const insights = buildArrivalInsights(
    [{ ...data, scopeName: "Entire Organization" }],
    { scopeLabel: "Organization" }
  );
  if (!config.charts.enabled) {
    const row = { ...data, scopeName: "Entire Organization" };
    return (
      <Box className="reportTableContainer arrivalRatesSummaryBlock" mt="20px">
        <EnterpriseReportSummary
          title="Daily Arrival Demand Summary"
          kpis={insights.kpis}
          tables={insights.tables}
          notes={insights.notes}
        />
        <ConfiguredReportTable
          columns={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
          rows={[row]}
          renderConfig={config}
          renderCell={renderCell}
        />
      </Box>
    );
  }

  return (
    <>
      <Box className="reportContainer" mt="20px">
        <EnterpriseReportSummary
          title="Daily Arrival Demand Summary"
          kpis={insights.kpis}
          tables={insights.tables}
          notes={insights.notes}
        />
        <ArrivalRatesPerDayTable
          average={(average)}
          min={(min)}
          max={(max)}
          total={(total)}
          title={title}
        />

        <Box mt="20px" mb="20px">
          <LineGraph
            chart={chart}
            height={"300px"}
            title={"Entire Organization Arrival Rates, Day by Day Comparison"}
          />
        </Box>
      </Box>
    </>
  );
};

export default ArrivalRatesPerDay;
